import {
    AlertCircle,
    BellRinging,
    Calendar,
    CheckCircleBroken,
    Eye,
    Link,
    StarOne,
    TagOne,
    UsersOne,
} from "@/Icons";
import { isEmpty, isNil, pickBy } from "lodash";

export { default as Filters } from "./Filters.vue";
export { default as FilterList } from "./FilterList.vue";
export { default as Filter } from "./Filter.vue";
export { default as ActiveFilters } from "./ActiveFilters.vue";

export const FilterType = Object.freeze({
    STATUS: "status",
    LINKED_TO: "linked_to",
    ASSIGNED_TO: "assigned_to",
    EXPIRATION_DATE: "expiration_date",
    NOTIFICATION_DATE: "notification_date",
    DUE_DATE: "due_date",
    COMPLETED_DATE: "completed_date",
    CREATED_DATE: "created_date",
    PURCHASED_DATE: "purchased_date",
    VISIBILITY: "visibility",
    PRIORITY: "priority",
    CATEGORY: "category",
    BRAND: "brand",
    SUPPLIER: "supplier",
    TAGS: "tags",
    TASK_TYPE: "task_type",
});

export const filters = [
    {
        id: FilterType.STATUS,
        icon: CheckCircleBroken,
        label: "components.filters.status.label",
    },
    {
        id: FilterType.LINKED_TO,
        icon: Link,
        label: "components.filters.linked_to.label",
    },
    {
        id: FilterType.ASSIGNED_TO,
        icon: UsersOne,
        label: "components.filters.assigned_to.label",
    },
    {
        id: FilterType.EXPIRATION_DATE,
        icon: Calendar,
        label: "components.filters.expiration_date.label",
    },
    {
        id: FilterType.NOTIFICATION_DATE,
        icon: BellRinging,
        label: "components.filters.notification_date.label",
    },
    {
        id: FilterType.DUE_DATE,
        icon: Calendar,
        label: "components.filters.due_date.label",
    },
    {
        id: FilterType.VISIBILITY,
        icon: Eye,
        label: "components.filters.visibility.label",
    },
    {
        id: FilterType.PRIORITY,
        icon: AlertCircle,
        label: "components.filters.priority.label",
    },
    {
        id: FilterType.CATEGORY,
        icon: StarOne,
        label: "components.filters.category.label",
    },
    {
        id: FilterType.TAGS,
        icon: TagOne,
        label: "components.filters.tags.label",
    },
];

export class FilterStates {
    constructor({
        status = [],
        linked_to = [],
        assigned_to = [],
        expiration_date = [],
        notification_date = [],
        due_date = [],
        completed_date = [],
        created_date = [],
        visibility = null,
        priority = [],
        category = [],
        tags = [],
    } = {}) {
        this.status = status;
        this.linked_to = linked_to;
        this.assigned_to = assigned_to;
        this.expiration_date = expiration_date;
        this.notification_date = notification_date;
        this.due_date = due_date;
        this.completed_date = completed_date;
        this.created_date = created_date;
        this.visibility = visibility;
        this.priority = priority;
        this.category = category;
        this.tags = tags;
    }

    getActiveFilters() {
        return pickBy(this, (value) => !isNil(value) && !isEmpty(value));
    }

    getActiveFilterKeys() {
        return Object.keys(this.getActiveFilters());
    }
}
